import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePageViews = () => {
  let location = useLocation();

  useEffect(() => {
    // Assuming that `window.gtag` is available
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_path: location.pathname
      })
    }
  }, [location]);
};


export default () => {
  usePageViews();
  return null;
}
